module.exports = __webpack_public_path__ + "static/media/chart.56fcffbd.png";